/**
 *
 *
 * @export
 * @param {*} source 原对象
 * @param {*} target 目标对象
 * @returns
 */
export function mappingData(source, target) {
    const obj: object = {};
    for (const key in target) {
      if (target.hasOwnProperty(key) && typeof source[key] !== 'undefined') {
         obj[key] = source[key];
      }
    }
    return Object.assign({}, target, obj);
  }
export function dateFormat(date, pattern) {
  let d = new Date(date).Format('yyyy-MM-dd hh:mm:ss');
  if (pattern) {
    d = new Date(date).Format(pattern);
  }
  return d.toLocaleString();
}
Date.prototype.Format = function(fmt) {
  const o = {
    'M+': this.getMonth() + 1,                   // 月份
    'd+': this.getDate(),                        // 日
    'h+': this.getHours(),                       // 小时
    'm+': this.getMinutes(),                     // 分
    's+': this.getSeconds(),                     // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds(),                  // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (const k in Object.keys(o)) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  }
  return fmt;
};
// 返回数据
export function isExistLength(data: any) {
  return data && data.length > 0 ? true : false;
}
